<template>
  <div class="row">
    <snappy-table
      ref="table"
      :endpoint="'billing/subscriptions'"
      :endpoint-exclude-fleet="true"
      :columns="['id','plan','status_label', 'actions']"
      :headings="['Subscription','Plan','Status', 'Actions']"
      :templated-slot-names="['plan', 'actions']"
      record-type="Subscriptions"
    >
      <template #plan="{ row }">
        <div>
          <p>{{row.description}}</p>

          <ul v-if="row.addons.data.length">
            <li v-for="addon in row.addons.data">
              {{ addon.description }} <span v-if="addon.is_quantifiable">({{ addon.quantity }})</span>
              <a
                href="https://snappykraken.com/cancel"
                target="_blank"
                v-if="isCancellationEnabled"
                type="button"
                class="action-button btn btn-primary addon-cancel-btn"
                title="Cancel Addon"
                v-tooltip="'Cancel Addon'"
              >
                Cancel
              </a>
            </li>
          </ul>
        </div>
      </template>
      <template #actions="{ row }">
        <div style="width:100px;">
          <a
            href="https://snappykraken.com/cancel"
            target="_blank"
            v-if="isCancellationEnabled"
            type="button"
            class="action-button btn btn-primary subscription-cancel-btn"
            title="Cancel Subscription"
            v-tooltip="'Cancel Subscription'"
          >
            Cancel
          </a>
        </div>
      </template>
    </snappy-table>

    <cancellation-modal
      :chargebee-product-name="productName"
      :chargebee-parent-product-name="parentProductName"
      :shown="showCancellationModal"
      @hide="onHideModal('showCancellationModal')"
    ></cancellation-modal>

    <cancellation-disabled-modal :shown="showCancellationDisabledModal"
                                 @hide="onHideModal('showCancellationDisabledModal')"></cancellation-disabled-modal>
  </div>
</template>

<script>
import SnappyTable from '../components/SnappyTable';
import CancellationModal from '../components/subscriptions/CancellationModal';
import CancellationDisabledModal from '../components/subscriptions/CancellationDisabledModal';

export default {
  name: 'plan-cancellation-table',
  components: {SnappyTable, CancellationModal, CancellationDisabledModal},
  props: {
    fullName: {
      type: String,
      required: false,
    },
    email: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      showCancellationModal: false,
      showCancellationDisabledModal: false,
      subscriptionId: null,
      productName: '',
      parentProductName: '',
      isCancellationEnabled: true
    };
  },
  methods: {
    onCancelAddonButtonClick(event, addon, parentProductName) {
      this.subscriptionId = addon.id;

      if (addon.can_be_cancelled) {
        this.showCancellationModal = true;
      } else {
        this.showCancellationDisabledModal = true;
      }

      this.productName = addon.name;
      this.parentProductName = parentProductName;
    },
    onHideModal(variable) {
      this[variable] = false;
      this.subscriptionId = null;
    },
  },
  mounted() {
    let intercomSettings = {
      app_id: "koau9di8",
      custom_launcher_selector: '.intercom_launcher',
    };

    if (this.fullName) {
      intercomSettings.name = this.fullName;
    }

    if (this.email) {
      intercomSettings.email = this.email;
    }

    window.intercomSettings = intercomSettings;
  },
}
</script>

<style lang="scss">
.VueTables .table > tbody > tr > td {
  vertical-align: top;
}

.addon-cancel-btn {
  margin: 6px 0;
}
.addon-cancel-btn, 
.subscription-cancel-btn {
  text-decoration: none !important;

}
</style>
